import axios from 'axios'
import { getDeviceFingerprint } from '@/lib/device-fingerprint'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000'

export interface LoginResponse {
  accessToken: string
  user: {
    id: number
    telegramId: string
    username?: string
    firstName?: string
    lastName?: string
    level: number
    participationCount: number
    winCount: number
    subscription: any
  }
}

export async function login(initData: string): Promise<LoginResponse> {
  // Отпечаток устройства отправляем при каждой авторизации (антибот). null — логинимся без него.
  const device = await getDeviceFingerprint()
  const response = await axios.post<LoginResponse>(`${API_URL}/api/auth/login`, {
    initData,
    ...(device && {
      fingerprint: device.fingerprint,
      fingerprintComponents: device.components,
      deviceId: device.deviceId,
      platform: device.platform,
    }),
  })
  return response.data
}

// В части Telegram WebView (заблокированное хранилище/приватный режим) прямой
// доступ к localStorage бросает исключение и роняет приложение в белый экран.
// Поэтому оборачиваем доступ в try/catch и держим in-memory фолбэк.
const TOKEN_KEY = 'accessToken'
let inMemoryToken: string | null = null

export function getAccessToken(): string | null {
  try {
    const stored = localStorage.getItem(TOKEN_KEY)
    if (stored !== null) return stored
  } catch {
    // localStorage недоступен — используем in-memory
  }
  return inMemoryToken
}

export function setAccessToken(token: string): void {
  inMemoryToken = token
  try {
    localStorage.setItem(TOKEN_KEY, token)
  } catch {
    // localStorage недоступен — токен останется только in-memory
  }
}

export function removeAccessToken(): void {
  inMemoryToken = null
  try {
    localStorage.removeItem(TOKEN_KEY)
  } catch {
    // localStorage недоступен — игнорируем
  }
}
